var _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVadEnabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4bdf00;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.5,9c-.3,0-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5h15c.3,0,.5.2.5.5v1c0,.3-.2.5-.5.5H.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.5,0H.5C.2,0,0,.2,0,.5v4c0,.3.2.5.5.5h1c.3,0,.5-.2.5-.5v-2.5h2.5c.3,0,.5-.2.5-.5V.5c0-.3-.2-.5-.5-.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.5,0h4c.3,0,.5.2.5.5v4c0,.3-.2.5-.5.5h-1c-.3,0-.5-.2-.5-.5v-2.5h-2.5c-.3,0-.5-.2-.5-.5V.5c0-.3.2-.5.5-.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.5,16H.5c-.3,0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h1c.3,0,.5.2.5.5v2.5h2.5c.3,0,.5.2.5.5v1c0,.3-.2.5-.5.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.5,16h4c.3,0,.5-.2.5-.5v-4c0-.3-.2-.5-.5-.5h-1c-.3,0-.5.2-.5.5v2.5h-2.5c-.3,0-.5.2-.5.5v1c0,.3.2.5.5.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVadEnabled);
export default __webpack_public_path__ + "static/media/vadEnabled.a09499755b9f36ecc9a89641a0b18147.svg";
export { ForwardRef as ReactComponent };